import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PowerResponse } from '../../interfaces/beans.interface';
import { PowerCatalogService } from '../../services/power-catalog.service';
import { Observable } from 'rxjs';


class PowersOfAttorney {
  id: string ='';
  name: string ='';
  created_at: Date; 
  tenancy: Tenancy = new Tenancy();
  public_notary = new PublicNotary();
  real_state: RealState = new RealState();
  start_at: Date;
  end_at: Date;
  limits: string;
  comments: string;
  type: string;
  extension: string;
  attributes: [][] = []; 
  userTaxid: string;
}

class Reciver {
  tax_id: string ='';
  name: string ='';
}

class Society {
  tax_id: string ='';
  name: string ='';
}

class PowerType {
  id: string ='';
  name: string ='';
}

class PublicNotary {
  id: string = '';
  name: string = '';
  society: Society = new Society(); 
  zip: string = '';
  num: string = '';
  user_taxid: string= '';
}

class RealState {
  id: string = '';
  date: Date;
  zip: string = '';
  user_taxid: string= '';
}

class Tenancy {
  id: string = '';
  name: string = '';
  taxid: string = '';
  zip: string = ''; 
  user_taxid: string = '';  
}


@Component({
  selector: 'app-power-modal',
  templateUrl: './power-modal.component.html',
  styleUrls: ['./power-modal.component.css']
})
export class PowerModalComponent implements OnInit {

  private readonly MAX_DOC_BYTES = 20 * 1024 * 1024;
  private readonly ALLOWED_DOC_MIME = new Set([
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/jpg'
  ]);

  tenancyPdfFile: File | null = null;
  originalPdfFile: File | null = null;
  registeredPdfFile: File | null = null;

  tenancyPdfLabel = '';
  originalPdfLabel = '';
  registeredPdfLabel = '';
  docFileError: string | null = null;

  @Input() my_modal_title:string = "Agregar Poder";
  @Input() my_modal_content:string = "Detalle del Poder";

  powersOfAttorney: PowersOfAttorney = new PowersOfAttorney();

  powerCatalogData_type?: Observable<PowerResponse>;
  powerCatalogData_extension?: Observable<PowerResponse>;
  powerCatalogData_attributes?: Observable<PowerResponse>;
  powerCatalogSociety?: Observable<PowerResponse>;
  // powerCatalog_PublicNotary?: Observable<PowerResponse>;
  powerCatalog_PublicNotary?: Observable<any[]>;
  type_catalog: [][] = [];
  extension_catalog: [][] = [];
  attributes_catalog: [][] = []; 
  selectedSociety: string ="Demostenes";
  selectedSocietyInParent: string; // Stores the selected society's RFC from child component
  minDaysPower: number = 5;
  isRecipmentCollapsed = false;
  isPropertyCollapsed = true;
  isIssuerCollapsed = true;
  isDetailCollapsed = true;

  publicNotaries: any[] = [];
  // groupedNotariesByState: { [key: string]: any[] } = {};
  groupedNotariesByState: any = {};
  selectedState: string = '';
  filteredNotaries: any[] = [];
  searchNotaryName: string = '';
    

  collapseStates = {
    recipment: false,
    issuer: true,
    property: true,
    detail: true,
    preview: true,
};


  constructor(public activeModal: NgbActiveModal,
    private powerCatalogService: PowerCatalogService,
  ) { }

  
  ngOnInit(): void {
    this.powerCatalogData_type = this.powerCatalogService.getAll('power-type');
    this.powerCatalogData_extension = this.powerCatalogService.getAll('power-extension');
    this.powerCatalogData_attributes = this.powerCatalogService.getAll('power-attributes');
    // this.powerCatalog_PublicNotary = this.powerCatalogService.getAll('public-notaries');
    this.powerCatalog_PublicNotary = this.powerCatalogService.getAll2<any[]>('public-notaries');

  
    this.powersOfAttorney.userTaxid = localStorage.getItem('userTaxId');
  
    this.powerCatalog_PublicNotary.subscribe((response) => {
      // console.log('Received notaries response:', response); // This is an ARRAY []
      const notaries = response;  // Just assign it directly
      this.groupNotariesByState(notaries);
    });
  }
  

  groupNotariesByState(notaries: any[]) {
    const grouped: { [key: string]: any[] } = {};
    notaries.forEach(notary => {
      const formattedState = this.capitalizeWords(notary.state);
      if (!grouped[formattedState]) {
        grouped[formattedState] = [];
      }
      grouped[formattedState].push(notary);
    });
    this.groupedNotariesByState = grouped;
  }
  
  capitalizeWords(str: string | null | undefined): string {
    if (!str) return '';
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }
  

  filterNotaries() {
    if (this.selectedState && this.groupedNotariesByState[this.selectedState]) {
      this.filteredNotaries = this.groupedNotariesByState[this.selectedState];
    } else {
      this.filteredNotaries = [];
    }
  
    if (this.searchNotaryName) {
      this.filteredNotaries = this.filteredNotaries.filter(notary =>
        notary.name.toLowerCase().includes(this.searchNotaryName.toLowerCase())
      );
    }
  }
  

  private validateDocFile(file: File): boolean {
    this.docFileError = null;
    if (file.size > this.MAX_DOC_BYTES) {
      this.docFileError = 'El archivo supera el límite de 20 MB.';
      return false;
    }
    const mime = (file.type || '').toLowerCase();
    const okMime = this.ALLOWED_DOC_MIME.has(mime);
    const okExt = /\.(pdf|jpe?g|png)$/i.test(file.name);
    if (!okMime && !okExt) {
      this.docFileError = 'Solo se permiten archivos PDF, JPEG o PNG.';
      return false;
    }
    return true;
  }

  onTenancyPdfSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      this.tenancyPdfFile = null;
      this.tenancyPdfLabel = '';
      return;
    }
    if (!this.validateDocFile(file)) {
      input.value = '';
      return;
    }
    this.tenancyPdfFile = file;
    this.tenancyPdfLabel = file.name;
  }

  onOriginalPdfSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      this.originalPdfFile = null;
      this.originalPdfLabel = '';
      return;
    }
    if (!this.validateDocFile(file)) {
      input.value = '';
      return;
    }
    this.originalPdfFile = file;
    this.originalPdfLabel = file.name;
  }

  onRegisteredPdfSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      this.registeredPdfFile = null;
      this.registeredPdfLabel = '';
      return;
    }
    if (!this.validateDocFile(file)) {
      input.value = '';
      return;
    }
    this.registeredPdfFile = file;
    this.registeredPdfLabel = file.name;
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        resolve(result.split(',')[1] || result);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private async buildPowerPayload(): Promise<Record<string, unknown>> {
    const t = this.powersOfAttorney.tenancy;
    let tenancyPdfBase64: string | undefined;
    let tenancyPdfFileName: string | undefined;
    let tenancyPdfContentType: string | undefined;
    if (this.tenancyPdfFile) {
      tenancyPdfBase64 = await this.fileToBase64(this.tenancyPdfFile);
      tenancyPdfFileName = this.tenancyPdfFile.name;
      tenancyPdfContentType = this.tenancyPdfFile.type || 'application/octet-stream';
    }

    let originalPdfBase64: string | undefined;
    let originalPdfFileName: string | undefined;
    let originalPdfContentType: string | undefined;
    if (this.originalPdfFile) {
      originalPdfBase64 = await this.fileToBase64(this.originalPdfFile);
      originalPdfFileName = this.originalPdfFile.name;
      originalPdfContentType = this.originalPdfFile.type || 'application/octet-stream';
    }

    let registeredPdfBase64: string | undefined;
    let registeredPdfFileName: string | undefined;
    let registeredPdfContentType: string | undefined;
    if (this.registeredPdfFile) {
      registeredPdfBase64 = await this.fileToBase64(this.registeredPdfFile);
      registeredPdfFileName = this.registeredPdfFile.name;
      registeredPdfContentType = this.registeredPdfFile.type || 'application/octet-stream';
    }

    const rawAttrs = this.powersOfAttorney.attributes as unknown;
    const attributes: string[] = Array.isArray(rawAttrs)
      ? rawAttrs.map((a) => String(a))
      : [];

    const societyTaxId =
      this.powersOfAttorney.public_notary?.society?.tax_id || this.selectedSocietyInParent || '';

    return {
      tenancy: {
        name: t.name,
        taxid: t.taxid,
        zip: t.zip,
        tenancyPdfBase64,
        tenancyPdfFileName,
        tenancyPdfContentType
      },
      public_notary: {
        id: String(this.powersOfAttorney.public_notary?.id ?? ''),
        society: { tax_id: societyTaxId }
      },
      real_state: {
        id: this.powersOfAttorney.real_state?.id,
        date: this.powersOfAttorney.real_state?.date,
        zip: this.powersOfAttorney.real_state?.zip
      },
      start_at: this.powersOfAttorney.start_at,
      end_at: this.powersOfAttorney.end_at,
      limits: this.powersOfAttorney.limits,
      comments: this.powersOfAttorney.comments,
      type: String(this.powersOfAttorney.type),
      extension: String(this.powersOfAttorney.extension),
      attributes,
      userTaxid: this.powersOfAttorney.userTaxid,
      originalPdfBase64,
      originalPdfFileName,
      originalPdfContentType,
      registeredPdfBase64,
      registeredPdfFileName,
      registeredPdfContentType
    };
  }

  async closeModalWithResult() {
    this.docFileError = null;
    try {
      const payload = await this.buildPowerPayload();
      this.activeModal.close(payload);
    } catch (e) {
      console.error('Error building power payload', e);
      this.docFileError = 'No se pudieron leer los archivos. Intente de nuevo.';
    }
  } 

  closeModalWithoutResult() {
    // Dismiss the modal without passing data
    this.activeModal.dismiss('Dismissed without result');
  }

  // Method to handle the event and update selectedSocietyInParent
  onSocietySelected(selectedSociety: string) {
    this.selectedSocietyInParent = selectedSociety;
    this.powersOfAttorney.public_notary.society.tax_id= this.selectedSocietyInParent;
    // this.powersOfAttorney.society.tax_id = selectedSociety;
    console.log('Selected Society in Parent:', this.selectedSocietyInParent);
  }

  validateDateRange() {
    const startDate = new Date(this.powersOfAttorney.start_at);
    const endDate = new Date(this.powersOfAttorney.end_at);
  
    if (this.powersOfAttorney.start_at && this.powersOfAttorney.end_at) {
      const diffInDays = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
      return diffInDays >= this.minDaysPower;
    }
    return true; // Returns true if either date is not filled in, so validation only applies when both dates are present
  }
 
 
  toggleCollapse(section: string) {
    // Reset all sections to collapsed
    Object.keys(this.collapseStates).forEach(key => {
        this.collapseStates[key] = true;
    });

    // Expand the clicked section
    this.collapseStates[section] = false;
  }
  
  isRecipmentComplete(): boolean {
    return (
        this.powersOfAttorney.tenancy.name.trim() !== '' &&
        this.powersOfAttorney.tenancy.zip.trim() !== ''
    );
  }

  isIssuerComplete(): boolean {
    return (
      (this.powersOfAttorney.public_notary.society.tax_id || '').trim() !== ''
    );
  }


  formatFileSize(sizeInBytes: number): string {
    const KB = 1024;
    const MB = KB * 1024;
    const GB = MB * 1024;
  
    if (sizeInBytes < KB) {
      return sizeInBytes + ' B';
    } else if (sizeInBytes < MB) {
      return (sizeInBytes / KB).toFixed(2) + ' KB';
    } else if (sizeInBytes < GB) {
      return (sizeInBytes / MB).toFixed(2) + ' MB';
    } else {
      return (sizeInBytes / GB).toFixed(2) + ' GB';
    }
  }

}
